import { useState, useEffect } from 'react';
import { LanguageVariant } from './languageVariants.types';
import { loadLanguageVariant, saveLanguageVariant } from './languageVariantStorage.service';

/**
 * useLanguageVariant hook
 * 
 * Manages language variant preference with localStorage persistence.
 * Integrated with unified storage service.
 * Default: neutral
 */
export function useLanguageVariant(): [
  LanguageVariant,
  (variant: LanguageVariant) => void
] {
  const [variant, setVariantState] = useState<LanguageVariant>('neutral');

  // Load preference from localStorage on mount
  useEffect(() => {
    const loaded = loadLanguageVariant();
    setVariantState(loaded);
  }, []);

  // Set variant and persist to localStorage
  const setVariant = (newVariant: LanguageVariant) => {
    setVariantState(newVariant);
    saveLanguageVariant(newVariant);
  };

  return [variant, setVariant];
}
